import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=8097ecae"
import script from "./CustomSwitch.vue?vue&type=script&lang=js"
export * from "./CustomSwitch.vue?vue&type=script&lang=js"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=8097ecae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports